import { URLS } from 'modules/axios'
import useApi from 'composables/useApi'

export function categoriaArquivosService() {
  const api = useApi()

  function getCategoriaArquivos(params) {
    return api.query(`${URLS.categoriaArquivos}`, params)
  }

  // function patchComentario(id, data) {
  //   return api.mutation(`${URLS.comentarios}${id}/`, 'PATCH', data)
  // }

  return {
    getCategoriaArquivos,
    ...api,
  }
}
